import { useEffect, useState } from 'react';

const useIntervalTransition = (endValue: number, duration: number): number => {
    const [currentValue, setCurrentValue] = useState<number>(0);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentValue((prevValue) => {
                const increment = Math.ceil((endValue - prevValue) / 10);
                const newValue = prevValue + increment;
                return newValue >= endValue ? endValue : newValue;
            });
        }, duration);

        return () => {
            clearInterval(intervalId);
            setCurrentValue(0);
        };
    }, [endValue, duration]);

    return currentValue;
};

export default useIntervalTransition;
